import PropTypes from 'prop-types';

const DaysConversionLeadTimeLabel = ({ leadTimeHours }) => {
   const numberInDays = Math.ceil(leadTimeHours / 8);
    return  `${numberInDays} ${numberInDays > 1 ? 'Days' : 'Day'}`
};

DaysConversionLeadTimeLabel.propTypes = {
  leadTimeHours: PropTypes.number.isRequired,
  roundToNearestWeek: PropTypes.bool.isRequired,
};

DaysConversionLeadTimeLabel.defaultProps = {
  roundToNearestWeek: false,
};

export default DaysConversionLeadTimeLabel;
